module.exports = __webpack_public_path__ + "static/img/home2-slider.bd92fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home2/home2-slider.png
// module id = s6ax
// module chunks = 36